var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncuietoareAntiefractie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb3eb45d-36be-4326-ae34-2979f73f5def",
    "data-name": "incuietoare_antiefractie",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.51 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a598e1ca-1c55-48df-b340-d9c58a63b857,.e7a0781e-b600-4a3f-a1b1-b97bc8e2cf34{fill:none;}.a598e1ca-1c55-48df-b340-d9c58a63b857,.e5786f31-0fdf-4db9-b826-e5c7fe7585e8,.e7a0781e-b600-4a3f-a1b1-b97bc8e2cf34{stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.e5786f31-0fdf-4db9-b826-e5c7fe7585e8,.e7a0781e-b600-4a3f-a1b1-b97bc8e2cf34{stroke-width:5px;}.a598e1ca-1c55-48df-b340-d9c58a63b857{stroke-width:8px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "incuietoare_antiefractie") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f238e0dd-8e6b-4eb7-8558-0398010fc4da",
    "data-name": "Shield copy 3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "e7a0781e-b600-4a3f-a1b1-b97bc8e2cf34",
    points: "6.08 30.49 82.23 30.71 116.75 37.77 140.45 60.29 148.01 94.9 139.77 122.41 112.27 132.04 92.6 124.1 87.65 109.91 95.56 97.85 110.8 97.89 112.68 81.88 96.96 67.91 79.89 68.65 62.15 72.93 24.07 72.82"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e5786f31-0fdf-4db9-b826-e5c7fe7585e8",
    cx: 99,
    cy: 86,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a598e1ca-1c55-48df-b340-d9c58a63b857",
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 194
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncuietoareAntiefractie);
export default __webpack_public_path__ + "static/media/incuietoare_antiefractie.34776fdab9804ff0f49481d4b244bf4d.svg";
export { ForwardRef as ReactComponent };